import React from 'react';
import LeftMenu from './LeftMenu';

import { host } from '../../assets/options';
import NoResults from '../../components/NoResults';

const Item = props => {
    let item = props.data;

    return (
        <a href={item.url} target="_blank" className='publications--href' rel="noopener noreferrer">
            <div className="flex-item flexItemMenu flexItemMenu__publication">
                <div className="Shadow"></div>

                <div className="mycontext publication__mycontext">
                    <p className='publication__title'>{item.name}</p>
                </div>

                <div className="img_container"
                     style={{backgroundImage: `url(${item.img !== '' ? " " + host + "/public/uploads/" + item.img + " " : ''})`}}></div>
            </div>
        </a>
    );
}

class Items extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            showAll: false,
            companyName: '',
            searchQuery: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            items: nextProps.data,
            companyName: nextProps.company
        });
    }

    handleSearchChange = (e) => {
        this.setState({searchQuery: e.target.value, showAll: false});
    }

    getFilteredItems() {
        const {items, searchQuery} = this.state;
        if (!searchQuery.trim()) return items;

        return items.filter(item =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }

    loadItems() {
        let items = [];
        const filteredItems = this.getFilteredItems();

        if (filteredItems.length === 0 && this.state.searchQuery.trim()) {
            return <NoResults searchQuery={this.state.searchQuery}/>;
        }

        let mql = window.matchMedia('(max-width: 1024px)').matches;
        const itemsCount = (!this.state.showAll && mql && filteredItems.length > 3) ? 3 : filteredItems.length;

        for (let i = 0; i < itemsCount; i++) {
            items.push(<Item key={i} data={filteredItems[i]}/>);
        }

        if (!this.state.showAll && mql && filteredItems.length > 3) items.push(
            <button className="seeMoreBtn" onClick={() => {
                this.setState({showAll: true})
            }}>
                Տեսնել բոլորը
            </button>);

        return items;
    }

    render() {
        let filteredItems = this.getFilteredItems();

        return (
            <React.Fragment>
                <div className="MyBodyContainer InMenu publications">
                    <LeftMenu this={this.props.this}/>

                    <div className="list-with-filter">
                        <div className="ResultsContainer publications-results">
                            <p className="categoryTitle">{this.state.companyName}</p>
                            <p className="SeachResults">գտնվել է {filteredItems.length} հրապարակում</p>
                        </div>
                        <div className="searchContainer">
                            <input
                                type="text"
                                className="searchInput"
                                placeholder="Որոնել..."
                                value={this.state.searchQuery}
                                onChange={this.handleSearchChange}
                            />
                        </div>

                        <div className="flex-container flexfixer fcr">
                            {this.loadItems()}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Items;
